import React from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';
import { EventDropdown } from '../../';

const Common = (props) => {
  
  const {
    competitionId,
    code,
    date,
    published ,
    event,
    competitionRulesURL
  } = props.data;

  const { onChange, onToggle, onEventChange } = props;

  return (
    <div>
      <Form.Group>
        {!competitionId && <EventDropdown
                               width={6}
                               required
                               value={event.id}
                               onSubmit={onEventChange}/>}
        {competitionId && <Form.Input
                              width={6}
                              required
                              label='Event'
                              disabled={true}
                              value={event.title} />}
        <Form.Input
          width={10}
          disabled
          label='Event ID'
          placeholder=''
          name='event.id'
          value={event.id} />
      </Form.Group>
      <Form.Group widths='equal'>
        <Form.Input
          required
          label='Code (2-5 characters)'
          placeholder=''
          name='code'
          value={code}
          onChange={onChange} />
        <DateInput
          dateFormat='YYYY-MM-DD'
          label="Date"
          name="date"
          value={date}
          iconPosition="left"
          onChange={onChange} />
      </Form.Group>
      <Form.Input
        required
        label='URL for competiton rules'
        placeholder='https://....'
        name='competitionRulesURL'
        value={competitionRulesURL}
        onChange={onChange} />
      <Form.Field
        control={Checkbox}
        label='Published (competitions is made public and visible to all the users)'
        name='published'
        checked={published}
        onChange={onToggle} />
    </div>
  );
};

export default Common;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/Common.js